import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="text-white/40 py-12 md:py-16 relative overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #150e28 0%, #0c0814 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-30" />
      <div className="absolute top-0 left-0 right-0 divider-purple" />
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="https://public.readdy.ai/ai/img_res/b3359781-4566-444a-8e5e-8e158f0fdcfb.png" alt="PolyWin Logo" className="w-8 h-8 md:w-9 md:h-9 object-contain rounded-lg" />
              <span className="text-xl md:text-2xl font-bold text-white font-heading">Poly<span className="text-purple-400">Win</span></span>
            </div>
            <p className="text-white/35 leading-relaxed text-sm">{t('footer.tagline')}</p>
          </div>
          <div>
            <h4 className="font-bold text-sm md:text-base text-white mb-3 md:mb-4">{t('footer.product')}</h4>
            <ul className="space-y-2 md:space-y-3">
              {[
                { href: '#core-logic', labelKey: 'footer.link0' },
                { href: '#fund', labelKey: 'footer.link1' },
                { href: '#advantage', labelKey: 'footer.link2' },
                { href: '#narrative', labelKey: 'footer.link3' },
              ].map(link => (
                <li key={link.labelKey}>
                  <a href={link.href} className="text-white/35 hover:text-purple-400 transition-colors text-sm cursor-pointer">{t(link.labelKey)}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-sm md:text-base text-white mb-3 md:mb-4">{t('footer.resources')}</h4>
            <ul className="space-y-2 md:space-y-3">
              {['footer.res0','footer.res1','footer.res2','footer.res3'].map(key => (
                <li key={key}>
                  <a href="#" className="text-white/35 hover:text-purple-400 transition-colors text-sm cursor-pointer">{t(key)}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-sm md:text-base text-white mb-3 md:mb-4">{t('footer.social')}</h4>
            <div className="flex items-center gap-2 md:gap-2.5 flex-wrap">
              {[
                { icon: 'ri-twitter-x-line', label: 'Twitter', href: '#' },
                { icon: 'ri-telegram-line', label: 'Telegram', href: 'https://t.me/PolywinAi' },
              ].map(social => (
                <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.label} className="w-9 h-9 rounded-full bg-white/[0.04] border border-white/8 hover:bg-purple-400/15 hover:border-purple-400/30 hover:text-purple-400 flex items-center justify-center transition-all text-white/35 cursor-pointer">
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="border-t border-purple-500/10 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4">
            <div className="text-white/25 text-sm">{t('footer.copyright')}</div>
            <div className="flex items-center gap-4 md:gap-6 text-sm">
              <a href="#" className="text-white/25 hover:text-purple-400 transition-colors cursor-pointer">{t('footer.privacy')}</a>
              <a href="#" className="text-white/25 hover:text-purple-400 transition-colors cursor-pointer">{t('footer.terms')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
